/**
 * Token 持有器
 * 
 * 用于在 API 请求中同步获取 Token。
 * 由 auth store 在初始化和登录时更新。
 * 
 * 这解决了 API 拦截器无法异步获取加密 Token 的问题。
 * 
 * @module utils/token-holder
 */

/**
 * 内存中的 Token 持有器
 * 避免在每次 API 请求时从 localStorage 读取（可能是加密的）
 */
class TokenHolder {
  private _accessToken: string = ''
  private _refreshToken: string = ''

  /**
   * 设置访问 Token
   */
  setAccessToken(token: string): void {
    this._accessToken = token
  }

  /**
   * 获取访问 Token
   */
  getAccessToken(): string {
    return this._accessToken
  }

  /**
   * 设置刷新 Token
   */
  setRefreshToken(token: string): void {
    this._refreshToken = token
  }

  /**
   * 获取刷新 Token
   */
  getRefreshToken(): string {
    return this._refreshToken
  }

  /**
   * 设置所有 Token
   */
  setTokens(accessToken: string, refreshToken?: string): void {
    this._accessToken = accessToken
    if (refreshToken !== undefined) {
      this._refreshToken = refreshToken
    }
  }

  /**
   * 清除所有 Token
   */
  clearTokens(): void {
    this._accessToken = ''
    this._refreshToken = ''
  }

  /**
   * 检查是否有访问 Token
   */
  hasAccessToken(): boolean {
    return !!this._accessToken
  }
}

// 导出单例
export const tokenHolder = new TokenHolder()

export default tokenHolder
